<div class="content-block">

    <!-- Content Header (Page header) -->
    
    <div class="content-header">
       <div class="container-fluid">
         <div class="row">
           <div class="col-sm-6">
             <h1 class="m-0 text-dark">Articolo: {{articolo?.descrizione}}</h1>
           </div><!-- /.col -->
           <div class="col-sm-6">
             <ol class="breadcrumb float-sm-right">
               <li class="breadcrumb-item"><a href="/home" title="Dashboard">Dashboard</a></li>
               <li class="breadcrumb-item"><a href="/tabelle/articoli" title="Elenco articoli">Articoli</a></li>
               <li class="breadcrumb-item">{{articolo?.descrizione}}</li>
             </ol>
           </div><!-- /.col -->
         </div><!-- /.row -->
       </div><!-- /.container-fluid -->
     </div>
     <!-- /.content-header -->
</div>

<div class="content-block">
    <div class="row">   
        <div class="col-md-12">
            <div class="card">
                <div class="nav-tabs-custom">
                  <ul class="nav nav-pills">
                   <!-- <li class="nav-item"><a class="nav-link active" href="#dettaglio-dip" data-bs-toggle="tab">Dettaglio articolo</a></li>
                    <li class="nav-item"><a class="nav-link" href="#dettaglio-allegati" data-bs-toggle="tab">Allegati</a></li>-->
                    <li class="nav-item"><a class="nav-link active" href="#dettaglio-scadenze" data-bs-toggle="tab">Scadenze</a></li>
                  </ul>
                </div>
                <div class="card-body">
                    <div class="tab-content">
                      <div class="tab-pane" id="dettaglio-dip">
                        <!--<app-form-dipendente  [idDipendente]="idDipendente"></app-form-dipendente>-->
                    </div><!-- /.tab-pane -->  
                      
                      <div class="tab-pane" id="dettaglio-allegati">
                            
                        </div><!-- /.tab-pane -->
                        <div class="active tab-pane" id="dettaglio-scadenze">              
                            <app-grid-scadenze-articoli [idArticolo]="idArticolo"></app-grid-scadenze-articoli>    
                        </div>
                    </div> <!-- fine tab-content-->

                </div><!-- fine card-body-->
            </div> <!--fine card-->
        </div>
    </div>

</div>
